import { useContent } from "@/context/ContentContext";
import Discography from "@/components/site/Discography";
import FullDiscography from "@/components/site/FullDiscography";
import PageLoader from "@/components/site/PageLoader";

export default function DiscographyPage() {
  const c = useContent();
  if (!c) return <PageLoader />;
  return (
    <>
      <Discography items={c.discography || []} />
      <FullDiscography />
    </>
  );
}
